/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { UsersListComp, Header, NewUserModal } from "../components";
import { NotificationModal } from "@vlinder-web/notification-modal-v2-widget-react";
import { routes } from "../../../services/appNavigatorService/config/routes.config.json";
import { Tabs, Tab } from "react-bootstrap";
import { Paginate } from "@vlinder-web/paginate-widget-react";
import { StateOSD } from "@vlinder-web/state-osd-v2-widget-react";
import {
  AppNavigatorService,
  BlockListUserPageService,
} from "../../../services";
import { SearchFilter } from "../../../widgets/filter-widget-react";
import {
  useSMUsersListPageGetContent,
  useSMInviteUser,
  useSMUsersListDelegatePageGetContent,
  useSMWhitelistUser,
} from "../machines";
import { VApplication } from "../../../application";
import { SettingsComp } from "../components/Settings";
import { UsersListDelegateComp } from "../components/UsersListCompDelegate";

const getAppNavService = () => {
  const app = VApplication.getInstance();
  return app?.getSync("services.AppNavigatorService") as AppNavigatorService;
};

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    "services.BlockListUserPageService"
  ) as BlockListUserPageService;
};

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setRefreshPagination] = useState(new Date());
  const [refreshDelegatePagination, setRefreshDelegatePagination] = useState(
    new Date()
  );
  const [showNoModal, setShowNoModal] = useState<boolean>(true);
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const history = useHistory();
  const srv = getSrv();
  const [role, setRole] = useState("");
  const appNavSrv = getAppNavService().whoAmI();
  appNavSrv
    .then((resolvedValue) => {
      const UserRole = resolvedValue.whoami;
      setRole(UserRole);
    })
    .catch((error) => {
      console.error(error);
    });
  useEffect(() => {
    srv?.resetCriteria();
    srv?.resetCriteriaDelegate();
  }, []);
  const { inviteUserMachine, inviteUserSend, inviteUserState } =
    useSMInviteUser({});
  const { usersListPageSend, usersListPageState, usersListPageMachine } =
    useSMUsersListPageGetContent({});
  const { whiteListUserSend, whiteListUserState } = useSMWhitelistUser({});
  const { usersListDelegatePageSend, usersListDelegatePageState } =
    useSMUsersListDelegatePageGetContent({});

  const onRefresh = (id: string) => {
    usersListPageSend("TRIGGER_REFRESH", {});
    usersListDelegatePageSend("TRIGGER_REFRESH", {});
    setRefreshPagination(new Date());
    setRefreshDelegatePagination(new Date());
  };

  const onInviteUsers = (ids: any) => {
    inviteUserSend("START", {
      payload: ids,
    });
  };

  const onTogglePress = (
    key: string,
    item: { id: string; email: string; vuid: string }
  ) => {
    console.log(`onTogglePress :`, key, item);
    if (key === "whitelist") {
      console.log(`onTogglePress :`);
      // props?.onTogglePress && props?.onTogglePress(item?.id);
      inviteUserSend("START", {
        payload: item?.email,
      });
    }
  };
  const onTogglePressDelegate = (
    key: string,
    item: { id: string; email: string; vuid: string; costumeId: string }
  ) => {
    console.log(`onTogglePress :`, key, item);
    if (key === "whitelist") {
      console.log(`onTogglePress :`);
      // props?.onTogglePress && props?.onTogglePress(item?.id);
      whiteListUserSend("START", {
        payload: item?.costumeId,
      });
    }
  };

  const onApplyFilter = (data: any, status: string) => {
    let criteria = {};
    if (status) {
      criteria = {
        accountStatus__in: status,
        ...data,
      };
    } else {
      criteria = {
        ...data,
      };
    }

    console.log("onApplyFilter--> criteria:", data);
    usersListPageSend("TRIGGER_REFRESH", {
      criteria: criteria,
    });
  };

  const onApplyFilterDelegate = (data: any, status: string) => {
    let criteria = {};
    if (status) {
      criteria = {
        accountStatus__in: status,
        ...data,
      };
    } else {
      criteria = {
        ...data,
      };
    }

    console.log("onApplyFilter--> criteria:", data);
    usersListDelegatePageSend("TRIGGER_REFRESH", {
      criteria: criteria,
    });
  };

  const _renderNotifications = () => {
    if (
      inviteUserState?.matches("INVITE_USER_SUCCESS") ||
      whiteListUserState?.matches("WHITELIST_USER_SUCCESS")
    ) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.userInviteSuccess || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderErrorModals = () => {
    if (inviteUserState?.matches("INVITE_USER_FAILED")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.inviteUser || {})}
          description={[inviteUserState?.event?.data?.value]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (whiteListUserState?.matches("WHITELIST_USER_FAILED")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.inviteUser || {})}
          description={[whiteListUserState?.event?.data?.value]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };

  const onClearFilter = () => {
    srv?.resetCriteria();
    usersListPageSend("TRIGGER_REFRESH", {});
    setRefreshPagination(new Date());
  };

  const onClearFilterDelegate = () => {
    srv?.resetCriteria();
    usersListDelegatePageSend("TRIGGER_REFRESH", {});
    setRefreshDelegatePagination(new Date());
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onRefreshClick={onRefresh}
          />
        </>
      );
    }
    return null;
  };
  const _renderSettings = () => {
    if (staticPageContentConfig?.settings) {
      return (
        <>
          <SettingsComp
            {...(staticPageContentConfig?.settings || {})}
            onApplyFilter={onApplyFilter}
            onClearFilter={onClearFilter}
          />
        </>
      );
    }
    return null;
  };

  const _renderSettingsDelegate = () => {
    if (staticPageContentConfig?.settings) {
      return (
        <>
          <SettingsComp
            {...(staticPageContentConfig?.settings || {})}
            onApplyFilter={onApplyFilterDelegate}
            onClearFilter={onClearFilterDelegate}
          />
        </>
      );
    }
    return null;
  };
  const onPaginationChange = (event: any) => {
    usersListPageSend("TRIGGER_REFRESH", {
      offset: event?.selected * 10,
      size: 10,
    });
  };
  const onPaginationDelegateChange = (event: any) => {
    usersListDelegatePageSend("TRIGGER_REFRESH", {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    console.log(
      "pagination in userlist===",
      usersListPageState?.event?.data?.value
    );
    return (
      <Paginate
        {...(usersListPageState?.event?.data?.value || {})}
        onPageChange={onPaginationChange}
        totalItems={usersListPageState?.event?.data?.value?.ultUsers?.length}
        key={refreshPagination}
      />
    );
  };

  const _renderPaginationDelegate = () => {
    console.log(
      "pagination in userlist===",
      usersListDelegatePageState?.event?.data?.value
    );
    return (
      <Paginate
        {...(usersListDelegatePageState?.event?.data?.value || {})}
        onPageChange={onPaginationDelegateChange}
        totalItems={
          usersListDelegatePageState?.event?.data?.value?.ultUsers?.length
        }
        key={refreshDelegatePagination}
      />
    );
  };

  const _renderPage = () => {
    if (inviteUserState?.matches("INVITE_USER")) {
      return (
        <StateOSD {...(staticPageContentConfig?.loading?.inviteUser || {})} />
      );
    }

    if (usersListPageState?.matches("RENDER_PAGE")) {
      return (
        <>
          {usersListPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.usersEmpty || {})}
            />
          ) : (
            <UsersListComp
              {...(usersListPageState?.event?.data?.value || {})}
              inviteUsers={onInviteUsers}
              onTogglePress={onTogglePress}
              onRowClick={props?.onRowClick && props?.onRowClick}
              ultInviteUser={onInviteUsers}
            />
          )}
        </>
      );
    }
    if (usersListPageState?.matches("GET_PAGE_CONTENT")) {
      return (
        <StateOSD {...(staticPageContentConfig?.loading?.loadingUsers || {})} />
      );
    }
    return null;
  };

  const _renderPageDelegate = () => {
    if (whiteListUserState?.matches("WHITELIST_USER")) {
      return (
        <StateOSD {...(staticPageContentConfig?.loading?.inviteUser || {})} />
      );
    }

    if (usersListDelegatePageState?.matches("RENDER_PAGE")) {
      return (
        <>
          {usersListDelegatePageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.usersEmpty || {})}
            />
          ) : (
            <UsersListDelegateComp
              {...(usersListDelegatePageState?.event?.data?.value || {})}
              inviteUsers={onInviteUsers}
              onTogglePress={onTogglePressDelegate}
              onRowClick={props?.onRowClick && props?.onRowClick}
              ultInviteUser={onInviteUsers}
            />
          )}
        </>
      );
    }
    if (usersListDelegatePageState?.matches("GET_PAGE_CONTENT")) {
      return (
        <StateOSD {...(staticPageContentConfig?.loading?.loadingUsers || {})} />
      );
    }
    return null;
  };

  // return (
  //   <div>
  //     {_renderHeader()}
  //     {_renderSettings()}
  //     {_renderPage()}
  //     {_renderPagination()}
  //     {_renderNotifications()}
  //     {_renderErrorModals()}
  //     <div style={{ height: "150px" }}></div>
  //   </div>
  // );
  return (
    <div>
      {_renderHeader()}
      {_renderNotifications()}
      {_renderErrorModals()}
      <Tabs defaultActiveKey="settings" id="comm-tabs" className="mb-3">
        <Tab eventKey="settings" title="Blocked Users">
          {_renderSettings()}
          {_renderPage()}
          {_renderPagination()}
          <div style={{ height: "150px" }}></div>
        </Tab>

        <Tab eventKey="second" title="Blocked Delegatees">
          {_renderSettingsDelegate()}
          {_renderPageDelegate()}
          {_renderPaginationDelegate()}
          <div style={{ height: "150px" }}></div>
        </Tab>
      </Tabs>
    </div>
  );
};
